import React, { PureComponent } from 'react';
import Immutable, { fromJS } from 'immutable';
import _ from 'lodash';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Checkbox } from 'antd';
import FIELD_TYPES from '../../../configs/fieldTypes';
import viewSettingsActions from '../../../actions/viewSettingsActions';
import dndContext from '../../../services/dndContext';
import { connect } from '../../StateProvider';
import FieldConfigItem from './FieldConfigItem';
import Icon from '../UI/Icon';
import ButtonTransparent from '../UI/ButtonTransparent';

import styles from './fieldConfig.less';

class FieldConfigMenu extends PureComponent {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    catalogId: PropTypes.string.isRequired,
    showHiddenFields: PropTypes.bool,
    sortable: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      fields: Immutable.Map(),
      visibleFields: {},
      fieldsOrder: [],
    };
  }

  /* SET */

  componentDidMount() {
    this.setFields();
    this.setFieldsVisible();
  }

  componentDidUpdate(prevProps, prevState) {
    // visiblity chaged
    if (this.props.fields !== prevProps.fields || this.props.visibleFields !== prevProps.visibleFields) {
      this.setFieldsVisible();
    }

    // order chaged
    if (
      this.props.fields !== prevProps.fields ||
      this.props.fieldsOrder !== prevProps.fieldsOrder ||
      this.props.viewMode !== prevProps.viewMode
    ) {
      this.setFields();
    }
  }

  setFields = () => {
    let { fields, fieldsOrder, showHiddenFields } = this.props;

    // fields order
    fieldsOrder = fieldsOrder ? fieldsOrder.toJS() : [];
    fieldsOrder = _.uniq(fieldsOrder);
    const fieldIds = fields ? fields.map((col) => col.get('id')).toArray() : [];
    const notSetOrderOnField = _.difference(fieldIds, fieldsOrder);
    fieldsOrder = (fieldsOrder || []).filter((id) => fieldIds.indexOf(id) !== -1).concat(notSetOrderOnField);

    // fields
    fields = fields
      .filter(
        (col) =>
          col.get('type') !== FIELD_TYPES.GROUP &&
          col.get('type') !== FIELD_TYPES.BUTTON &&
          col.get('type') !== FIELD_TYPES.IFRAME,
      )
      .filter((col) => showHiddenFields || !col.get('hidden'))
      .filter((col) => !col.get('hiddenByRights'))
      .map((col) => {
        const index = fieldsOrder.indexOf(col.get('id'));
        return col.set('_order', index === -1 ? Number.MAX_SAFE_INTEGER : index);
      })
      .sort((c1, c2) => c1.get('_order') - c2.get('_order'));

    // visible fields

    this.setState({ fields, fieldsOrder });
  };

  setFieldsVisible = () => {
    // visible fields
    const { fields, hidden, visibleFields } = this.props;
    const defaultVisible = this.props.defaultVisible === undefined ? true : this.props.defaultVisible;

    const newVisibleFields = {};
    fields
      .filter(
        (col) =>
          col.get('type') !== FIELD_TYPES.GROUP &&
          col.get('type') !== FIELD_TYPES.BUTTON &&
          col.get('type') !== FIELD_TYPES.IFRAME,
      )
      .filter((col) => hidden || !col.get('hidden'))
      .filter((col) => !col.get('hiddenByRights'))
      .forEach((field) => {
        const fieldId = field.get('id');
        // visibleFields - это Map { fieldId: { visible: true, width: 150, pinned: true } }
        const visible = (visibleFields && visibleFields.getIn([fieldId, 'visible'])) ?? defaultVisible;
        const pinned = (visibleFields && visibleFields.getIn([fieldId, 'pinned'])) || false;
        newVisibleFields[fieldId] = { visible, pinned };
      });

    this.setState({ visibleFields: newVisibleFields });
  };

  /* CHECK */
  hasVisibleFields = () => {
    const { visibleFields } = this.state;
    return !!_.findKey(visibleFields, (field) => Boolean(field.visible));
  };

  hasNotVisibleFields = () => {
    const { visibleFields } = this.state;
    return !!_.findKey(visibleFields, (f) => f.visible !== true);
  };

  /* EVENTS */

  /* Change Visible */
  onVisibleChange(fieldId, visible) {
    // update local state - создаем НОВЫЙ объект, не мутируем старый
    const { visibleFields } = this.state;
    const newVisibleFields = { ...visibleFields, [fieldId]: { visible } };
    this.setState({ visibleFields: newVisibleFields });

    // update remote state
    viewSettingsActions.setFieldVisibility({
      catalogId: this.props.catalogId,
      viewMode: this.props.viewMode,
      viewId: this.props.viewId,
      fieldId,
      visible,
    });
  }

  /* Change Pinned */
  onPinnedChange(fieldId, pinned) {
    const { visibleFields } = this.state;
    this.setState({ visibleFields: { ...visibleFields, [fieldId]: { ...visibleFields[fieldId], pinned: !pinned } } });

    // update remote state
    viewSettingsActions.setFieldPinned({
      catalogId: this.props.catalogId,
      viewMode: this.props.viewMode,
      viewId: this.props.viewId,
      fieldId,
      pinned: !pinned,
    });
  }

  showAllFields = () => {
    this.setAllFields(true);
  };

  hideAllFields = () => {
    this.setAllFields(false);
  };

  setAllFields(value) {
    const { catalogId, viewMode, viewId } = this.props;
    const defaultVisible = this.props.defaultVisible === undefined ? true : this.props.defaultVisible;

    const newVisibleFields = { ...this.state.visibleFields };
    const fieldIdsToUpdate = [];

    this.state.fields.forEach((field) => {
      const fieldId = field.get('id');
      newVisibleFields[fieldId].visible = value === undefined ? defaultVisible : value;
      fieldIdsToUpdate.push(fieldId);
    });

    this.setState({ visibleFields: newVisibleFields });

    if (fieldIdsToUpdate.length > 0) {
      viewSettingsActions.setAllFieldsVisibility({
        catalogId,
        viewMode,
        viewId,
        fieldIds: fieldIdsToUpdate,
        visible: value,
      });
    }
  }

  /* Change order  */
  moveItem = (fieldId, afterFieldId) => {
    if (this.field !== fieldId || this.afterFieldId !== afterFieldId) {
      this.field = fieldId;
      this.afterFieldId = afterFieldId;

      const fieldIndex = this.state.fieldsOrder.indexOf(fieldId);
      const newFieldIndex = this.state.fieldsOrder.indexOf(afterFieldId);

      const newOrder = this.state.fieldsOrder.slice();
      newOrder.splice(fieldIndex, 1);
      newOrder.splice(newFieldIndex, 0, fieldId);

      this.setState({
        fieldsOrder: newOrder,
      });
    }
  };

  onDragEnd = () => {
    viewSettingsActions.setFieldsOrder({
      catalogId: this.props.catalogId,
      viewMode: this.props.viewMode,
      viewId: this.props.viewId,
      fieldsOrder: this.state.fieldsOrder,
    });
  };

  render() {
    const { fields, visibleFields } = this.state;
    const { viewMode, sortable, t, className } = this.props;

    const allVisible = this.hasVisibleFields() && !this.hasNotVisibleFields();
    const indeterminate = this.hasVisibleFields() && this.hasNotVisibleFields();
    const visibleCount = _.filter(visibleFields, (f) => f.visible).length;

    return (
      <div className={cn(styles.menuWrapper, className)}>
        <div className={styles.menuHeader}>
          <Checkbox
            className={styles.headerItem}
            indeterminate={indeterminate}
            checked={allVisible}
            onChange={(e) => (e.target.checked ? this.showAllFields() : this.hideAllFields())}
          >
            <span className={styles.menuHeaderCount}>
              {visibleCount} / {fields.size}
            </span>
            <span className={styles.menuHeaderTitle}> {t('views.ofFields')}</span>
          </Checkbox>
        </div>
        <ul className={cn('ant-dropdown-menu ant-dropdown-menu-vertical', styles.menu)}>
          {fields.map((col) => {
            const colId = col.get('id');
            return (
              <FieldConfigItem
                viewMode={viewMode}
                key={colId}
                field={col}
                visible={visibleFields[colId].visible}
                onVisibleChange={(e) => this.onVisibleChange(colId, e.target.checked)}
                pinned={visibleFields[colId].pinned}
                onPinnedChange={() => this.onPinnedChange(colId, visibleFields[colId].pinned)}
                sortable={sortable}
                onDragEnd={this.onDragEnd}
                moveItem={this.moveItem}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default withTranslation()(
  dndContext(
    connect(
      FieldConfigMenu,
      {
        viewSettings: ['viewSettings', 'catalogs'],
      },
      (props, { viewSettings }) => {
        // Извлекаем fields напрямую - та же ссылка если данные не менялись
        const settings = viewSettings && viewSettings.getIn([props.catalogId, 'views', props.viewId, props.viewMode]);
        const visibleFields = settings && settings.get('fields');
        const fieldsOrder = settings && settings.get('fieldsOrder');

        return {
          ...props,
          fieldsOrder: fieldsOrder || Immutable.List(),
          visibleFields: visibleFields || Immutable.Map(),
        };
      },
    ),
  ),
);
